export default "__VITE_ASSET__6b7f9484__"